import styled from 'styled-components';

export const IconStyles = styled.span`
  > * {
    width: 1em;
    height: 1em;
  }
`;
